// Footer.js
import React from 'react';

function AdminFooter() {
  return (
    <footer className="admin-footer">
      <p className="p-3">© {new Date().getFullYear()} Manipal Dot Net</p>
      <p>
        Powered by <a href="https://www.manipal.net" >www.manipal.net</a>
      </p>
    </footer>
  );
}

export default AdminFooter;